import { CurrencyPipe, DatePipe, DecimalPipe, NgClass, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { InstrumentDetailsLinkComponent, WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, IconComponent, PillComponent } from '@zero/shared/ui-web-design-system';
import { PositionBase } from '../position-base/position-base.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[zero-position]',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InstrumentDetailsLinkComponent,
    WatchlistToggleComponent,
    NgClass,
    NgbTooltipModule,
    FormsModule,
    BlinkDirective,
    NgbDropdownModule,
    RouterLink,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    TranslocoPipe,
    ButtonComponent,
    IconComponent,
    PillComponent,
    UpperCasePipe,
  ],
})
export class PositionComponent extends PositionBase {
  public readonly instrumentDetail = this.commonRoutes.postlogin.instrument_detail;

  public protectOrder(): void {
    this.item.availableQuantity >= 1 && this.activateProtectOrderMode.emit();
  }
}
